var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "padding-top-4xl size-md tablet:size-sm",
      staticStyle: {
        "--sale-theme-color": "var(--fa-teal)",
        "--sale-theme-color-dk": "var(--fa-dk-teal)",
        "--sale-link-color": "var(--fa-navy)",
      },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row roomy margin-bottom-xl" }, [
          _c("div", { staticClass: "column-12" }, [
            _c(
              "div",
              {
                class: [
                  "display-flex flex-column tablet:flex-row message size-reset-md margin-bottom-0",
                  _vm.isProBacker || _vm.isBackerWithoutSubscription
                    ? "align-stretch tablet:align-top"
                    : "align-middle",
                ],
                staticStyle: {
                  "--message-background": "var(--sale-theme-color)",
                  "--message-border-color": "var(--sale-theme-color)",
                },
              },
              [
                _vm.hasPromoCode
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "card flat padding-x-xl padding-y-md tablet:margin-bottom-0 tablet:margin-right-2xl",
                        staticStyle: {
                          "background-color": "var(--sale-theme-color)",
                          border:
                            "var(--border-width-sm) dashed var(--fa-navy)",
                        },
                        attrs: {
                          "data-balloon-pos": "up",
                          "aria-label":
                            _vm.justCopied === "copyPromoCode"
                              ? "Copied!"
                              : "Copy Promo Code",
                        },
                        on: { click: _vm.copyPromoCode },
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticClass: "h4 text-center text-uppercase",
                            staticStyle: {
                              "letter-spacing": "var(--letter-spacing-2xl)",
                              "font-weight": "var(--font-weight-black)",
                            },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Copy"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "display-block margin-bottom-4xs",
                                staticStyle: { color: "var(--fa-navy)" },
                              },
                              [_vm._v(_vm._s(_vm.promoCode))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "display-block size-xs text-nowrap",
                                staticStyle: {
                                  color: "var(--sale-theme-color-dk)",
                                },
                              },
                              [_vm._v("promo code")]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "card padding-x-xl padding-y-md tablet:margin-bottom-0 tablet:margin-right-2xl",
                        staticStyle: { "background-color": "var(--fa-navy)" },
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticClass: "h4 text-center text-uppercase",
                            staticStyle: {
                              "letter-spacing": "var(--letter-spacing-2xl)",
                              "font-weight": "var(--font-weight-black)",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "display-block margin-bottom-4xs",
                                staticStyle: { color: "var(--white)" },
                              },
                              [_vm._v(_vm._s(_vm.discount) + "% off")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "display-block size-xs text-nowrap",
                                staticStyle: {
                                  color: "var(--sale-theme-color)",
                                },
                              },
                              [
                                _vm._v(
                                  "ends in " +
                                    _vm._s(_vm.daysLeft) +
                                    " " +
                                    _vm._s(
                                      _vm.formatPlural(_vm.daysLeft, "day")
                                    )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                _vm._v(" "),
                _vm.isProBacker || _vm.isBackerWithoutSubscription
                  ? _c("div", [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "--link-color": "var(--fa-navy)",
                            "--link-hover-color": "var(--fa-dk-blue)",
                          },
                        },
                        [
                          _vm._v(
                            "\n              Nearly ten years ago, you helped us make history as the most successful software Kickstarter ever. As a thank you, pre-order Font Awesome 7 with\n              a "
                          ),
                          _vm.isBackerWithoutSubscription
                            ? _c("span", [_vm._v("Pro or")])
                            : _vm._e(),
                          _vm._v(" Pro+ plan by "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.saleEndDateFormatted)),
                          ]),
                          _vm._v(" and lock in a\n              "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.discount) + "% annual discount"),
                          ]),
                          _vm._v(" for life!\n              "),
                          _vm.hasPromoCode
                            ? [
                                _vm._v("Use code "),
                                _c("strong", [_vm._v(_vm._s(_vm.promoCode))]),
                                _vm._v(
                                  " when updating your subscription.\n                "
                                ),
                                _c(
                                  "site-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "support",
                                        hash: "#promo-codes",
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: _vm.$v6.solid.faInfoCircle,
                                        "fixed-width": "",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Learn more"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _vm._v(
                                  " Plus, get instant access to Font Awesome 6."
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                    ])
                  : _c("div", [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "--link-color": "var(--fa-navy)",
                            "--link-hover-color": "var(--fa-dk-blue)",
                          },
                        },
                        [
                          _vm.hasPromoCode
                            ? _c("span", [_vm._v("Upgrade to a ")])
                            : _c("span", [
                                _vm._v(
                                  "Pre-order Font Awesome 7 with a Pro or"
                                ),
                              ]),
                          _vm._v(" Pro+ plan by\n              "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.saleEndDateFormatted)),
                          ]),
                          _vm._v(
                            " and lock-in a " +
                              _vm._s(_vm.discount) +
                              "% annual discount!\n              "
                          ),
                          _vm.hasPromoCode
                            ? [
                                _vm._v("Use code "),
                                _c("strong", [_vm._v(_vm._s(_vm.promoCode))]),
                                _vm._v(
                                  " when updating your subscription.\n                "
                                ),
                                _c(
                                  "site-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "support",
                                        hash: "#promo-codes",
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: _vm.$v6.solid.faInfoCircle,
                                        "fixed-width": "",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Learn more"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _vm._v(
                                  " Plus, get instant access to Font Awesome 6."
                                ),
                              ],
                        ],
                        2
                      ),
                    ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row roomy margin-top-xl align-stretch" }, [
      _c(
        "div",
        { staticClass: "column-6 display-flex flex-column align-end" },
        [
          _c("div", [
            _c("img", {
              staticStyle: {
                "max-height": "40px",
                "margin-right": "var(--spacing-md)",
              },
              attrs: {
                src: "https://img.fortawesome.com/1ce05b4b/dave-signature.svg",
                alt: "Signed Dave Gandy",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("p", { staticClass: "strong" }, [
              _vm._v("\n                    Dave Gandy\n                    "),
              _c(
                "span",
                {
                  staticClass: "display-block size-sm",
                  staticStyle: { color: "var(--sale-theme-color-dk)" },
                },
                [_vm._v("Founder + CEO")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column-6 display-flex flex-column align-end" },
        [
          _c("div", [
            _c("img", {
              staticStyle: {
                "max-height": "40px",
                "margin-right": "var(--spacing-md)",
              },
              attrs: {
                src: "https://img.fortawesome.com/1ce05b4b/travis-signature.svg",
                alt: "Signed Travis Chase",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("p", { staticClass: "strong" }, [
              _vm._v(
                "\n                    Travis Chase\n                    "
              ),
              _c(
                "span",
                {
                  staticClass: "display-block size-sm",
                  staticStyle: { color: "var(--sale-theme-color-dk)" },
                },
                [_vm._v("Founder + COO")]
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }